var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnMute = function SvgUnMute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9531 14.75C22.8481 14.75 21.7882 15.189 21.0068 15.9704C20.2254 16.7518 19.7865 17.8116 19.7865 18.9167V24.75C19.7865 25.8551 20.2254 26.9149 21.0068 27.6963C21.7882 28.4777 22.8481 28.9167 23.9531 28.9167C25.0582 28.9167 26.118 28.4777 26.8994 27.6963C27.6808 26.9149 28.1198 25.8551 28.1198 24.75V18.9167C28.1198 17.8116 27.6808 16.7518 26.8994 15.9704C26.118 15.189 25.0582 14.75 23.9531 14.75ZM17.2865 23.9167C17.5075 23.9167 17.7194 24.0045 17.8757 24.1607C18.032 24.317 18.1198 24.529 18.1198 24.75C18.1198 26.2971 18.7344 27.7808 19.8283 28.8748C20.9223 29.9688 22.406 30.5833 23.9531 30.5833C25.5002 30.5833 26.984 29.9688 28.0779 28.8748C29.1719 27.7808 29.7865 26.2971 29.7865 24.75C29.7865 24.529 29.8743 24.317 30.0305 24.1607C30.1868 24.0045 30.3988 23.9167 30.6198 23.9167C30.8408 23.9167 31.0528 24.0045 31.209 24.1607C31.3653 24.317 31.4531 24.529 31.4531 24.75C31.4535 26.5951 30.7737 28.3755 29.5438 29.7509C28.3139 31.1263 26.6201 32 24.7865 32.205V33.9167C24.7865 34.1377 24.6987 34.3496 24.5424 34.5059C24.3861 34.6622 24.1741 34.75 23.9531 34.75C23.7321 34.75 23.5201 34.6622 23.3639 34.5059C23.2076 34.3496 23.1198 34.1377 23.1198 33.9167V32.205C21.2861 32 19.5924 31.1263 18.3625 29.7509C17.1326 28.3755 16.4528 26.5951 16.4531 24.75C16.4531 24.529 16.5409 24.317 16.6972 24.1607C16.8535 24.0045 17.0654 23.9167 17.2865 23.9167Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 15.25L33.8555 32.75",
    stroke: "#808080",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 16.25L32.8555 33.75",
    stroke: "#FCFCFC",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unMute.a221a9de719f5a24f572eb4cadf75edb.svg";